import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

import { LoadingOverlay } from "@/components/ui/loading-overlay";

export const Route = createFileRoute("/(meet)/meet/join/$roomName")({
  component: MeetJoinRedirectRoute,
});

/** Maps `/meet/join/:room` → in-SPA `/meet/:room` with query preserved. */
function MeetJoinRedirectRoute() {
  const { roomName } = Route.useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const sp = new URLSearchParams(
      typeof window !== "undefined" ? window.location.search : "",
    );
    const search = Object.fromEntries(sp.entries());
    navigate({
      to: "/meet/$roomName",
      params: { roomName },
      search,
      replace: true,
    });
  }, [navigate, roomName]);

  return <LoadingOverlay />;
}
